var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-mit-app-navigation"},[_c('v-navigation-drawer',{attrs:{"app":"","permanent":"","clipped":""}},[_c('MitMenu',{attrs:{"userModel":_vm.userModel,"userRoles":_vm.userRoles},on:{"logout":_vm.logout,"login":_vm.login}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }